import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import React from "react";
import { Control, useFieldArray } from "react-hook-form";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";

interface LinkInputGroupProps {
  control: Control<any>;
  baseName: string;
  title: string;
  maxLinks?: number;
}

const defaultLink = { label: "", url: "" };

export const LinkInputGroup: React.FC<LinkInputGroupProps> = ({
  control,
  baseName,
  title,
  maxLinks = 3,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: baseName,
  });

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-900">
          {title}
        </label>
        {fields.length < maxLinks && (
          <button
            type="button"
            onClick={() => append(defaultLink)}
            className="inline-flex items-center gap-1 rounded-md bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            title="Add link">
            <PlusIcon className="h-4 w-4" />
            Add
          </button>
        )}
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className="flex gap-2 items-center justify-between">
          <div className="flex gap-2 items-center flex-1">
            <div className="basis-[30%]">
              <FormInputComponent
                control={control}
                name={`${baseName}.${index}.label`}
                label="Label"
                placeholder="Example"
              />
            </div>

            <div className="basis-[70%]">
              <FormInputComponent
                control={control}
                name={`${baseName}.${index}.url`}
                label="URL"
                placeholder="https://example.com"
              />
            </div>
          </div>
          {fields.length > 1 && (
            <button
              type="button"
              onClick={() => remove(index)}
              className="ml-2 mt-auto rounded-md p-1 text-gray-400 hover:text-red-600"
              title="Remove link">
              <TrashIcon className="h-5 w-5" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
